import { css } from '@/styled-system/css';

const HDP_DESKTOP_HEADER_CONTAINER = 'hdpDesktopHeader';
// CSS equivalent of the old JS header-width thresholds. Keep this tied to
// container width because the HDP header can render inside a split content panel.
// These values match Panda's md/lg breakpoint tokens.

export const desktopHeader = css({
  display: 'none',
  lg: {
    display: 'block',
    paddingTop: 'zero',
    paddingBottom: 'default',
    position: 'sticky',
    top: 'var(--search-header-height, 0px)',
    background: 'bg.neutral',
    zIndex: 'zIndexParent',
    transitionProperty: 'box-shadow',
    transitionDuration: '0.2s',
    container: `${HDP_DESKTOP_HEADER_CONTAINER} / inline-size`,
  },
});

export const desktopHeaderColumns = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: 'default',
  minWidth: 0,
});

export const desktopHeaderLeft = css({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  minWidth: 0,
});

export const desktopHeaderRight = css({
  display: 'flex',
  gap: 'tighter',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexShrink: 1,
  minWidth: 0,
});

export const headerActionButton = css({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  textDecoration: 'none',
});

export const headerIconButton = css({
  flexShrink: 0,
});

export const headerCtaButton = css({
  flexShrink: 0,
  whiteSpace: 'nowrap',
});

export const headerCtaButtonLabel = css({
  '@container hdpDesktopHeader (max-width: 30em)': {
    display: 'none',
  },
});

export const utilityActionButton = css({
  '@container hdpDesktopHeader (max-width: 48em)': {
    paddingInline: 'tighter',
  },
});

export const utilityActionButtonLabel = css({
  '@container hdpDesktopHeader (max-width: 48em)': {
    display: 'none',
  },
});

export const utilityActionLabel = css({
  '@container hdpDesktopHeader (max-width: 34em)': {
    display: 'none',
  },
});
